import React, {useCallback, useState} from 'react';

import {Tooltip, TooltipContent} from '@optimaxdev/design-system';
import {Icon, Approve} from '@optimaxdev/icons';
import classNames from 'classnames';

import {QuestionMark} from 'desktop/components/helpers/icons/questionMark/questionMark';
import {isUhcEnabled} from 'libs/rollout';

import {ApplyAllowanceTooltipConnected} from '../applyAllowanceTooltip/applyAllowanceTooltip';

import s from './cartItemLabel.scss';

type PropsType = {
    name: string;
    id: string;
    isUhc: boolean;
    isUhcEligible: boolean;
};

/**
 * Displays label which is stated you added cart item under UHC allowance
 * @params {PropsType} props for added as UHC label
 * @returns {React.ReactElement} component for added as UHC label
 */
export const CartItemLabel: React.FC<PropsType> = React.memo(({id, isUhc, isUhcEligible, name}) => {
    const [isTooltipOpen, setTooltipVisibility] = useState(false);

    const closeTooltip = useCallback(() => {
        setTooltipVisibility(false);
    }, [setTooltipVisibility]);

    const onChange = useCallback(
        (visibility: boolean) => setTooltipVisibility(visibility),
        [setTooltipVisibility],
    );

    const toggleTooltip = () => {
        setTooltipVisibility(!isTooltipOpen);
    };

    if (!isUhcEnabled()) return null;
    if (isUhc)
        return (
            <div className={classNames(s.label, s.wrapper)}>
                <div className={s.icon}>
                    <Icon aria-label="Check sign" icon={Approve} />
                </div>
                <span>Plan Allowance Applied</span>
            </div>
        );
    if (isUhcEligible)
        return (
            <div className={s.wrapper}>
                <button className={s.label} onClick={toggleTooltip} type="button">
                    20% Exclusive Discount &nbsp;
                </button>
                <Tooltip
                    content={
                        <TooltipContent>
                            <ApplyAllowanceTooltipConnected
                                cancel={closeTooltip}
                                id={id}
                                name={name}
                            />
                        </TooltipContent>
                    }
                    arrowColor="#f7f8f9"
                    closeTrigger="hover"
                    elevation={3}
                    isOpen={isTooltipOpen}
                    onChange={onChange}
                    openTrigger="hover"
                    position="bottom"
                >
                    <QuestionMark color="white" />
                </Tooltip>
            </div>
        );
    return <p className={s.note}>- Not covered by your plan -</p>;
});

CartItemLabel.displayName = 'CartItemLabel';
